// Metal selection chip — chromatic liquid-chrome shader under the active dial
// station, with a glass layer stacked over it (glass-over-metal overlap).
// Recipe reverse-engineered from the Framer tutorial: white-dominant ramp,
// Scale .77 / Stretch .23 / Angle 65 / Repeats 2 / RGB Split .42 / Evolution 1.
function initMetalChip(tabs){
  if(!tabs || tabs.__chipInit || tabs.classList.contains('coll-dial')) return;   // one chip: perfume dial only
  tabs.__chipInit = true;

  var chip = document.createElement('div');
  chip.className = 'metal-chip';
  var canvas = document.createElement('canvas');
  var glass = document.createElement('div');
  glass.className = 'chip-glass';                 // the stacked glass layer
  chip.appendChild(canvas); chip.appendChild(glass);
  tabs.insertBefore(chip, tabs.firstChild);

  function seat(){
    var btn = tabs.querySelector('button.active');
    if(!btn) return;
    chip.style.left = (btn.offsetLeft - 2) + 'px';
    chip.style.width = (btn.offsetWidth + 4) + 'px';
  }
  tabs.__seatChip = seat;
  tabs.addEventListener('click', function(){ requestAnimationFrame(seat); });
  window.addEventListener('resize', seat);

  var gl = canvas.getContext('webgl', {premultipliedAlpha:false});
  if(!gl){ canvas.style.background = 'linear-gradient(65deg,#fff,#474D54,#fff,#3F3F40)'; seat(); return; }

  var VS = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  var FS = [
    'precision mediump float;',
    'uniform vec2 u_res;uniform float u_time;',
    // white-dominant chrome ramp (video recipe): W .28g W W .25g .25g
    'vec3 STOPS(int i){',
    '  if(i==0) return vec3(1.);',
    '  if(i==1) return vec3(.28,.30,.33);',
    '  if(i==2) return vec3(1.);',
    '  if(i==3) return vec3(1.);',
    '  if(i==4) return vec3(.25);',
    '  return vec3(.25);',
    '}',
    'float POS(int i){',
    '  if(i==0) return 0.0;',
    '  if(i==1) return .22;',
    '  if(i==2) return .45;',
    '  if(i==3) return .62;',
    '  if(i==4) return .82;',
    '  return 1.0;',
    '}',
    'vec3 ramp(float t){',
    '  t=fract(t);',
    '  vec3 c=STOPS(0);',
    '  for(int i=1;i<6;i++){',
    '    float a=POS(i-1),b=POS(i);',
    '    float w=smoothstep(a,mix(a,b,.18),t)-smoothstep(mix(a,b,.82),b,t);',
    '    c=mix(c,STOPS(i),clamp(w,0.,1.));',
    '  }',
    '  return c;',
    '}',
    'void main(){',
    '  vec2 uv=gl_FragCoord.xy/u_res;',
    '  uv.x*=u_res.x/u_res.y;',
    '  float t=u_time;',
    '  vec2 q=uv-vec2(u_res.x/u_res.y*.5,.5);',
    '  float a=radians(65.);',
    '  vec2 dir=vec2(cos(a),sin(a));',
    '  float warp=.38*sin(q.y*1.6+t*.4)+.22*sin(q.x*2.3-t*.31)+.16*sin((q.x+q.y)*3.1+t*.23);',
    '  float v=dot(q*vec2(1.,.23),dir)*.35 + warp + length(q)*.45;',  // features ~2.2x larger for the slim chip
    '  float rough=.22*(.06*sin(q.y*27.+t)+.04*sin(q.x*40.-t*.8));',
    '  float band=v*2.+rough+.1*sin(t*.5);',
    '  float s=.8*.06;',                                              // stronger split so fringes survive 20px height
    '  vec3 col;',
    '  col.r=ramp(band+s).r;col.g=ramp(band).g;col.b=ramp(band-s).b;',
    '  float edge=abs(fract(band)-.5);',
    '  vec3 fringe=vec3(.9+.1*sin(band*6.2831),.7+.3*sin(band*6.2831+2.1),1.)-col;',
    '  col+=fringe*smoothstep(.43,.5,edge)*.28;',
    '  gl_FragColor=vec4(col,1.);',
    '}'
  ].join('\n');

  function compile(type, src){
    var sh = gl.createShader(type);
    gl.shaderSource(sh, src); gl.compileShader(sh);
    if(!gl.getShaderParameter(sh, gl.COMPILE_STATUS)){
      console.error('metal-chip shader:', gl.getShaderInfoLog(sh));
      return null;
    }
    return sh;
  }
  var prog = gl.createProgram();
  var vs = compile(gl.VERTEX_SHADER, VS), fs = compile(gl.FRAGMENT_SHADER, FS);
  if(!vs || !fs) return;
  gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
  if(!gl.getProgramParameter(prog, gl.LINK_STATUS)){ console.error(gl.getProgramInfoLog(prog)); return; }
  gl.useProgram(prog);
  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 3,-1, -1,3]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'p');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  var uRes = gl.getUniformLocation(prog, 'u_res');
  var uTime = gl.getUniformLocation(prog, 'u_time');

  function size(){
    var r = chip.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    var w = Math.max(1, Math.round(r.width*dpr)), hh = Math.max(1, Math.round(r.height*dpr));
    if(canvas.width !== w || canvas.height !== hh){ canvas.width = w; canvas.height = hh; gl.viewport(0,0,w,hh); }
  }
  if(window.ResizeObserver) new ResizeObserver(size).observe(chip);

  function draw(ts){
    size();
    gl.uniform2f(uRes, canvas.width, canvas.height);
    gl.uniform1f(uTime, (ts||0)/1000);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
  }
  draw(0);
  (function loop(ts){ draw(ts); requestAnimationFrame(loop); })(0);

  requestAnimationFrame(seat);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ requestAnimationFrame(seat); });
}
window.initMetalChip = initMetalChip;
initMetalChip(document.getElementById('collTabs'));
